import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Table, Modal, Spinner, Alert } from "react-bootstrap";
import { Paper } from "@material-ui/core";
import { PremissionChecker } from "../../../services/PremissionChecker";
function MobileAppDomains() {
  const alert = useAlert();
  const user = useSelector((state) => state.user.user);
  const authtoken = localStorage.getItem("userToken");
  const [loading, setloading] = useState(false);
  const [isallfields, setisallfields] = useState(false);

  const [colorSchemeData, setColorSchemeData] = useState([]);
  const [domainsData, setDomainsData] = useState([]);
  const [addLoading, setAddLoading] = useState(false);

  const [addModal, setAddModal] = useState(false);
  const [colorSchemeId, setColorSchemeId] = useState("");
  const [domainSlug, setDomainSlug] = useState("");
  const [baseUrlText, setBaseUrlText] = useState("");

  const [editModal, setEditModal] = useState(false);
  const [editColorSchemeId, setEditColorSchemeId] = useState("");
  const [editDomainSlug, setEditDomainSlug] = useState("");
  const [editBaseUrlText, setEditBaseUrlText] = useState("");
  const [editDomainId, setEditDomainId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteDomainId, setDeleteDomainId] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    getColorSchemes();
    getDomains();
  }, []);

  const getColorSchemes = async () => {
    await fetch(`${baseUrl}/color-schemes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setColorSchemeData(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getDomains = async () => {
    setloading(true);
    await fetch(`${baseUrl}/domains`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setDomainsData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const addClassHandler = async () => {
    if (!colorSchemeId || !domainSlug || !baseUrlText) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    const data = {
      base_url: baseUrlText,
      color_scheme_id: colorSchemeId,
      domain_slug: domainSlug,
    };
    setAddLoading(true);

    await fetch(`${baseUrl}/domains`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          if (data.metadata.success) {
            alert.success("Domain successfully added");
            setAddModal(false);
            setAddLoading(false);
            getDomains();
            setColorSchemeId("");
            setDomainSlug("");
            setBaseUrlText("");
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setAddModal(false);
            setAddLoading(false);
          } else {
            alert.show("Something Went Wrong");
            setAddModal(false);
            setAddLoading(false);
          }
        }),
      )
      .catch((err) => {
        setAddLoading(false);
        setAddModal(false);
        console.log(err);
      });
  };

  const getEditClass = async (id) => {
    await fetch(`${baseUrl}/domains/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setEditColorSchemeId(data.payload?.color_scheme_id || "");
          setEditDomainSlug(data.payload?.domain_slug || "");
          setEditBaseUrlText(data.payload?.base_url || "");
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const updateHandler = async () => {
    if (!editColorSchemeId || !editDomainSlug || !editBaseUrlText) {
      setisallfields(true);
      return;
    }
    setisallfields(false);
    setSubmitLoading(true);
    const data = {
      base_url: editBaseUrlText,
      color_scheme_id: editColorSchemeId,
      domain_slug: editDomainSlug,
    };
    await fetch(`${baseUrl}/domains/${editDomainId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setSubmitLoading(false);
          if (data.metadata.success) {
            alert.success("Domain Successfully Updated");
            getDomains();
            setEditModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setSubmitLoading(false);
      });
  };

  const deleteHandle = async () => {
    setdeleteloading(true);

    await fetch(`${baseUrl}/domains/${deleteDomainId}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success(
              data.metadata.message || "Domain Successfully Deleted",
            );
            getDomains();
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.show("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div>
          <button
            onClick={() => setAddModal(true)}
            className="btn btn-primary mr-2"
          >
            Add Domain
          </button>
        </div>

        <Table className="mt-5" responsive>
          <thead>
            <tr className="text-center">
              <th>ID</th>
              <th>Color Scheme Name</th>
              <th>Domain Slug</th>
              <th>Base URL</th>
              <th>Update</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {domainsData?.map((domian, index) => (
              <tr className="text-center" key={index}>
                <td>{domian?.id}</td>
                <td>{domian?.color_scheme?.name}</td>
                <td>{domian?.domain_slug}</td>
                <td>{domian?.base_url}</td>
                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-primary-custom btn-sm mx-3"
                    onClick={() => {
                      getEditClass(domian?.id);
                      setEditDomainId(domian?.id);
                      setEditModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary-custom">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Write.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>

                <td>
                  <a
                    className="btn btn-icon btn-light btn-hover-danger btn-sm mx-3"
                    onClick={() => {
                      setDeleteDomainId(domian?.id);
                      setdeleteModal(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-danger">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/Communication/Delete-user.svg",
                        )}
                      />
                    </span>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        <div className="row justify-content-center">
          {loading && <span className="spinner-border"></span>}
        </div>

        {/* Add Class Modal */}
        <Modal show={addModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Domain
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Select Color Scheme <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <select
                  className="form-select h-40px"
                  value={colorSchemeId}
                  name="colorSchemeId"
                  id="colorSchemeId"
                  onChange={(e) => setColorSchemeId(e.target.value)}
                >
                  <option value="">Select Color Scheme</option>
                  {colorSchemeData?.map((colorScheme, index) => (
                    <option key={index} value={colorScheme.id}>
                      {colorScheme.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Enter Domain Slug <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={domainSlug}
                  onChange={(e) => setDomainSlug(e.target.value)}
                  placeholder="Enter Domain Slug"
                />
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Enter Base URL <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={baseUrlText}
                  onChange={(e) => setBaseUrlText(e.target.value)}
                  placeholder="Enter Base URL"
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>

          <Modal.Footer>
            {addLoading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addClassHandler}
              >
                Add
              </button>
            )}
            <button
              className="btn btn-danger btn_width"
              onClick={() => {
                setAddModal(false);
                setisallfields(false);
                setColorSchemeId("");
                setDomainSlug("");
                setBaseUrlText("");
              }}
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Domain Modal */}
        <Modal show={editModal} size="lg">
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Update Domain
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Select Color Scheme <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <select
                  className="form-select h-40px"
                  value={editColorSchemeId}
                  name="editColorSchemeId"
                  id="editColorSchemeId"
                  onChange={(e) => setEditColorSchemeId(e.target.value)}
                >
                  <option value="">Select Color Scheme</option>
                  {colorSchemeData?.map((colorScheme, index) => (
                    <option key={index} value={colorScheme.id}>
                      {colorScheme.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Enter Domain Slug <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editDomainSlug}
                  onChange={(e) => setEditDomainSlug(e.target.value)}
                  placeholder="Enter Domain Slug"
                />
              </div>
              <div className="col-md-6 col-sm-12 mb-3">
                <label className="form-control-label">
                  <b>
                    Enter Base URL <span style={{ color: "red" }}>*</span>{" "}
                  </b>
                </label>
                <input
                  className="form-control"
                  value={editBaseUrlText}
                  onChange={(e) => setEditBaseUrlText(e.target.value)}
                  placeholder="Enter Base URL"
                />
              </div>
            </div>

            {isallfields ? (
              <>
                <Alert
                  variant="danger"
                  onClose={() => setisallfields(false)}
                  dismissible
                >
                  <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                  <p>Please fill or select all fields</p>
                </Alert>
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer>
            {submitLoading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button onClick={updateHandler} className="btn btn-primary">
                Update
              </button>
            )}

            <button
              onClick={() => setEditModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Domain Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this domain?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Domain Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button onClick={deleteHandle} className="btn button_blue">
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
}

export default MobileAppDomains;
